import WebProperty from '@/features/web-property'
import UserManager from '@/features/user-manager/UserManager.vue'
import UserManagerEdit from '@/features/user-manager/Edit.vue'
import UserTab from '@/features/user-manager/UserTab.vue'
import RolesTab from '@/features/user-manager/RolesTab.vue'
import ProjectSettings from '@/features/project-settings'
import AccountTab from '@/features/project-settings/Account'
import Integrations from '@/features/integrations'
import ShopPropertiesTab from '@/features/project-settings/ShopProperties'
import PublishingTab from '@/features/project-settings/Publishing'
import RankTrackingTab from '@/features/project-settings/RankTracking'
import StrategyTab from '@/features/project-settings/Strategy'
import UrlAttributes from '@/features/url-attributes'
import Agency from '@/features/agency'
import AccountInfo from '@/features/agency/AccountInfo'
import BillingDashboard from '@/features/billing'
import Clients from '@/features/clients'
import ClientsEdit from '@/features/clients/Edit'
import GeneralInfoTab from '@/features/clients/GeneralInfo'
import RankReportTargetingTab from '@/features/clients/RankReportTargeting'
import MSVTab from '@/features/clients/MSV'
import UrlEdit from '@/features/url-census/Edit'
import UrlGeneralInfoTab from '@/features/url-census/GeneralInfo'
import UrlRankReportTargetingTab from '@/features/url-census/RankReportTargeting'
import AssociatedUrlAttributesTab from '@/features/url-census/AssociatedUrlAttributes'
import KeywordAttributes from '@/features/keyword-attributes/KeywordAttributes'
import BackgroundTasks from '@/features/backgroung-tasks'

export const workScreenRoutes = [
  {
    path: 'keyword_census',
    name: 'keyword_census',
    redirect: { name: 'keyword-census' }
  },
  {
    path: 'url_census',
    name: 'url_census',
    redirect: { name: 'url-census' }
  },
  {
    path: 'url',
    name: 'url',
    redirect: { name: 'url_census' }
  },
  {
    path: 'url/:id',
    name: 'url',
    component: UrlEdit,
    redirect: { name: 'UrlGeneralInfoTab' },
    children: [
      {
        path: 'general-info',
        name: 'UrlGeneralInfoTab',
        component: UrlGeneralInfoTab
      },
      {
        path: 'rank-report-targeting',
        name: 'UrlRankReportTargetingTab',
        component: UrlRankReportTargetingTab
      },
      {
        path: 'associated-url-attributes',
        name: 'AssociatedURLAttributesTab',
        component: AssociatedUrlAttributesTab
      }
    ]
  }
]

export const clientSettingsRoutes = [
  {
    path: 'url-attributes',
    name: 'url-attributes',
    component: UrlAttributes
  },
  {
    path: 'keyword-attributes',
    name: 'keyword-attributes',
    component: KeywordAttributes
  },
  {
    path: 'web_property',
    name: 'web_property',
    component: WebProperty
  },
  // {
  //   path: 'project-settings',
  //   name: 'project-settings',
  //   component: ProjectSettings
  // }
  {
    path: 'project-settings',
    name: 'project-settings',
    component: ProjectSettings,
    redirect: { name: 'AccountTab' },
    props: true,
    children: [
      {
        path: 'account',
        name: 'AccountTab',
        component: AccountTab
      },
      {
        path: 'strategy',
        name: 'StrategyTab',
        component: StrategyTab
      },
      {
        path: 'rank-tracking',
        name: 'RankTrackingTab',
        component: RankTrackingTab
      },
      {
        path: 'publishing',
        name: 'PublishingTab',
        component: PublishingTab
      },
      {
        path: 'integrations',
        name: 'integrations',
        component: Integrations,
        props: (route) => ({ integrationError: route.query.err, integrationStatus: route.query.integration_status })
      },
      {
        path: 'shop-properties',
        name: 'ShopPropertiesTab',
        component: ShopPropertiesTab
      },
    ]
  },
]

export const systemRoutes = [
  {
    path: 'clients',
    name: 'clients',
    component: Clients,
    props: (route) => ({ 'agencyFilterId': route.query.agency })
  },
  {
    path: 'clients/:id',
    name: 'clients',
    component: ClientsEdit,
    redirect: { name: 'GeneralInfoTab' },
    children: [
      {
        path: 'general-info',
        name: 'GeneralInfoTab',
        component: GeneralInfoTab
      },
      {
        path: 'rank-report-targeting',
        name: 'RankReportTargetingTab',
        component: RankReportTargetingTab
      },
      {
        path: 'monthly-search-value',
        name: 'MSVTab',
        component: MSVTab
      }
    ]
  },
  {
    path: 'account-info',
    name: 'account-info',
    component: AccountInfo
  },
  {
    path: 'agencies',
    name: 'agencies',
    component: Agency
  },
  {
    path: 'billing',
    name: 'billing',
    component: BillingDashboard
  },
  {
    path: 'background-tasks',
    name: 'background-tasks',
    component: BackgroundTasks
  },
  {
    path: 'tag',
    name: 'tag'
  },
  {
    path: 'url_analyser',
    name: 'url_analyser'
  },
  {
    path: 'user_manager',
    name: 'user_manager',
    component: UserManager
  },
  {
    path: 'user_manager/:id',
    name: 'user_manager',
    component: UserManagerEdit,
    redirect: { name: 'UserTab' },
    children: [
      {
        path: 'user',
        name: 'UserTab',
        component: UserTab
      },
      {
        path: 'agency-roles',
        name: 'AgencyRolesTab',
        component: RolesTab
      },
      {
        path: 'client-roles',
        name: 'ClientRolesTab',
        component: RolesTab
      }
    ]
  }
]
